import { getConfig, isWidgetConfig, registerXHeadersInterceptor, } from '@creditornot/converse-shared';
import axios from 'axios';
import { apiUrlByEnv } from './constants';
import { registerAuthInterceptor, registerTokenExpiredErrorInterceptor } from './axiosInterceptors';
let authAgent;
const getAuthAgent = () => {
    if (authAgent) {
        return authAgent;
    }
    authAgent = axios.create();
    authAgent.interceptors.request.use(request => {
        const config = getConfig();
        request.baseURL = `${apiUrlByEnv[config.env]}/auth-api`;
        return request;
    });
    registerXHeadersInterceptor(authAgent);
    return authAgent;
};
let authenticatedAuthAgent;
const getAuthenticatedAuthAgent = () => {
    if (authenticatedAuthAgent) {
        return authenticatedAuthAgent;
    }
    authenticatedAuthAgent = axios.create();
    authenticatedAuthAgent.interceptors.request.use(request => {
        const config = getConfig();
        request.baseURL = `${apiUrlByEnv[config.env]}/auth-api`;
        return request;
    });
    registerXHeadersInterceptor(authenticatedAuthAgent);
    registerAuthInterceptor(authenticatedAuthAgent);
    // response interceptors
    registerTokenExpiredErrorInterceptor(authenticatedAuthAgent);
    return authenticatedAuthAgent;
};
export const postToken = (grant) => getAuthAgent()
    .post('v1/token', grant)
    .then(response => response.data);
export const postTokenV2 = (grant) => getAuthAgent()
    .post('v2/token', grant)
    .then(response => response.data);
export const getAuthIdentity = () => getAuthenticatedAuthAgent()
    .get('v1/identity')
    .then(response => response.data);
// replace with authAgent as soon as /logout is migrated to auth-api
let logoutAgent;
const getLogoutAgent = () => {
    if (logoutAgent) {
        return logoutAgent;
    }
    logoutAgent = axios.create();
    logoutAgent.interceptors.request.use(request => {
        const config = getConfig();
        request.baseURL = `${apiUrlByEnv[config.env]}`;
        return request;
    });
    registerXHeadersInterceptor(logoutAgent);
    return logoutAgent;
};
export const postLogout = (refreshToken) => {
    const config = getConfig();
    let apiPath;
    // keep switch-case for exhaustive checks
    switch (config.sdkType) {
        case 'workspace':
            // TODO(chat-3350): to be defined at config level
            apiPath = `/workspace-api/v1/${config.workspaceId}/user/logout`;
            break;
        case 'widget':
            // TODO(chat-3350): to be defined at config level
            apiPath = `/widget-api/v1/${config.appId}/contact/logout`;
            break;
    }
    if (isWidgetConfig(config) && config.identityType === 'guest') {
        throw new Error('Guest logout is not supported');
    }
    return getLogoutAgent()
        .post(apiPath, {
        refreshToken,
    })
        .then(() => undefined);
};
//# sourceMappingURL=api.js.map